import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDesignSystem32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconDesignSystem32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m24.11 10.67 2.122-2.12-2.828-2.829-2.122 2.122zM8.444 20.683 19.868 9.257l2.829 2.828L11.272 23.51l-3.627.798zm13.543-5.058 5.66-5.66a2 2 0 0 0 0-2.829l-2.828-2.828a2 2 0 0 0-2.829 0l-5.66 5.66L11 4.637a3 3 0 0 0-4.243 0L4.635 6.758a3 3 0 0 0 0 4.243l5.33 5.33-3.35 3.35-1.26 5.726a1 1 0 0 0 1.192 1.191l5.726-1.26 3.349-3.35 5.375 5.375a3 3 0 0 0 4.243 0l2.121-2.121a3 3 0 0 0 0-4.243zm-1.414 1.414-3.536 3.536 5.375 5.375a1 1 0 0 0 1.414 0l2.122-2.121a1 1 0 0 0 0-1.415l-.473-.473-1.267 1.267a1 1 0 0 1-1.414-1.414l1.267-1.267-1.086-1.085-1.267 1.266a1 1 0 0 1-1.414-1.414l1.267-1.267zm-9.193-2.12L6.05 9.586a1 1 0 0 1 0-1.415l2.12-2.12a1 1 0 0 1 1.414 0l.476.475-1.267 1.267a1 1 0 0 0 1.414 1.414l1.267-1.267 1.085 1.086-1.266 1.267a1 1 0 0 0 1.414 1.414l1.267-1.267.94.942z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDesignSystem32);
